export default __webpack_public_path__ + "img/rule_reward_0-9009c45b.png";